import Vue from 'vue'

import apis from '@/api'

const queryFormList = (menuId, callback) => {
  return new Promise((resolve, reject) => {
    const request = {
      ...apis.QUERY_FORM_LIST,
      params: {
        menuId
      }
    }
    Vue.prototype.$request(request).asyncThen((resp) => {
      if (resp.code === 'ok') {
        callback(resp)
        resolve(resp.data)
      }
    })
  })
}

export default {
  editorConfigType: 'SELECT_ASSOCIATED_FORM',
  componentName: 'FormConfigAssociatedFormSelect',
  configProperty: 'associationFormId',
  extras: {
    queryFormList: queryFormList
  }
}
